import React from 'react';
import { useFormContext } from 'react-hook-form';
import { Edit2 } from 'react-feather';

const Step6ReviewSubmit = ({ onEdit }) => {
  const { getValues } = useFormContext();
  const formData = getValues();

  const formatDate = (dateString) => {
    if (!dateString) return '--';
    return new Date(dateString).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };
  console.log(formData)
  return (
    <div style={{
      maxWidth: '808px',
      width: '100%',
      background: '#fff',
      borderRadius: '10px',
      padding: '32px 36px',
    }}>
      <h5 style={{ fontWeight: '600', fontSize: '18px', marginBottom: '4px' }}>
        Review & Submit
      </h5>
      <p style={{ color: '#888', fontSize: '13px', marginBottom: '28px' }}>
        Review before submitting the request
      </p>

      {/* Brand Info Section */}
      <div style={sectionStyle}>
        <div style={sectionHeaderStyle}>
          <h6 style={sectionTitleStyle}>1 - Brand Info:</h6>
          <button
            type="button"
            onClick={() => onEdit(1)}
            style={editButtonStyle}
          >
            <Edit2 size={16} />
          </button>
        </div>
        <div style={sectionContentStyle}>
          {formData.brand_info?.brand_id ? (
            <p style={dataLineStyle}>Brand ID: {formData.brand_info.brand_id}</p>
          ) : null}
          <p style={dataLineStyle}>Brand Name: {formData.brand_info?.brand_name || '--'}</p>
          <p style={dataLineStyle}>Website: {formData.brand_info?.website || '--'}</p>
          {formData.brand_info?.deadline && (
            <p style={dataLineStyle}>Deadline: {formatDate(formData.brand_info.deadline)}</p>
          )}
          {formData.brand_info?.markets_of_interest?.length > 0 && (
            <p style={dataLineStyle}>Markets of Interest: {formData.brand_info?.markets_of_interest?.map((market) => market.label).join(', ')}</p>
          )}
        </div>
      </div>

      {/* Brand In Your Space Setup Section */}
      <div style={sectionStyle}>
        <div style={sectionHeaderStyle}>
          <h6 style={sectionTitleStyle}>2 - Brand In Your Space Setup:</h6>
          <button
            type="button"
            onClick={() => onEdit(2)}
            style={editButtonStyle}
          >
            <Edit2 size={16} />
          </button>
        </div>
        <div style={sectionContentStyle}>
          {formData.brand_in_space?.brands?.map((brand, idx) => (
            <p key={idx} style={dataLineStyle}>
              {brand.brand_id ? `ID ${brand.brand_id}: ` : ''}
              {brand.name || brand.brand_name || '--'} ({brand.website || '--'})
            </p>
          ))}
        </div>
      </div>

      {/* Exclusions Section */}
      <div style={sectionStyle}>
        <div style={sectionHeaderStyle}>
          <h6 style={sectionTitleStyle}>3 - Exclusions:</h6>
          <button
            type="button"
            onClick={() => onEdit(3)}
            style={editButtonStyle}
          >
            <Edit2 size={16} />
          </button>
        </div>
        <div style={sectionContentStyle}>
          {formData.exclusions?.brands?.map((brand, idx) => (
            <p key={idx} style={dataLineStyle}>
              {brand.brand_id ? `ID ${brand.brand_id}: ` : ''}
              {brand.name || 'none'} {brand.website ? `(${brand.website})` : ''}
            </p>
          ))}
        </div>
      </div>

      {/* Preferred Retailer Section */}
      <div style={sectionStyle}>
        <div style={sectionHeaderStyle}>
          <h6 style={sectionTitleStyle}>4 - Preferred Retailer:</h6>
          <button
            type="button"
            onClick={() => onEdit(4)}
            style={editButtonStyle}
          >
            <Edit2 size={16} />
          </button>
        </div>
        <div style={sectionContentStyle}>
          <p style={dataLineStyle}>
            {formData.preferred_retailer || 'Premium retailer in Europe aligned with sustainable fashion'}
          </p>
        </div>
      </div>

      {/* Find Matches Setup Section */}
      <div style={sectionStyle}>
        <div style={sectionHeaderStyle}>
          <h6 style={sectionTitleStyle}>5 - Find Matches Setup:</h6>
          <button
            type="button"
            onClick={() => onEdit(5)}
            style={editButtonStyle}
          >
            <Edit2 size={16} />
          </button>
        </div>
        <div style={sectionContentStyle}>
          {formData.find_matches?.type === 'standard' && (
            <>
              <p style={dataLineStyle}>Standard Method</p>
              <p style={dataLineStyle}>
                Remove previous matching: {formData.find_matches?.remove_previous_matching ? 'Yes' : 'No'}
              </p>
              <p style={dataLineStyle}>
                Removing existing next to brands &amp; competitors: {formData.brand_info?.remove_existing_next_to_brands_competitors ? 'Yes' : 'No'}
              </p>
            </>
          )}

          {formData.find_matches?.type === 'unique' && formData.find_matches?.unique_option === 'put_brand_retailers' && (
            <>
              <p style={dataLineStyle}>
                <strong>Unique Method (</strong>Put Brand B Retailers in Brand A<strong>)</strong>
              </p>
              {(Array.isArray(formData.find_matches?.brand_a)
                ? formData.find_matches.brand_a
                : formData.find_matches?.brand_a
                  ? [formData.find_matches.brand_a]
                  : []
              ).map((brand, idx) => (
                <p key={`a-${idx}`} style={dataLineStyle}>
                  Target: {brand.brand_id ? `ID ${brand.brand_id} - ` : ''}{brand.name} ({brand.website})
                </p>
              ))}
              {formData.find_matches?.brand_b?.map((brand, idx) => (
                <p key={`b-${idx}`} style={dataLineStyle}>
                  Source: {brand.brand_id ? `ID ${brand.brand_id} - ` : ''}{brand.name} ({brand.website})
                </p>
              ))}
              <p style={dataLineStyle}>
                {formData.find_matches?.match_type || 'Match'}
              </p>
              <p style={dataLineStyle}>
                Remove previous matching: {formData.find_matches?.remove_previous_matching ? 'Yes' : 'No'}
              </p>
              <p style={dataLineStyle}>
                Removing existing next to brands &amp; competitors: {formData.brand_info?.remove_existing_next_to_brands_competitors ? 'Yes' : 'No'}
              </p>
            </>
          )}

          {formData.find_matches?.type === 'unique' && formData.find_matches?.unique_option === 'take_working_retailers' && (
            <>
              <p style={dataLineStyle}>
                <strong>Unique Method (</strong>Private Brands in Your Space<strong>)</strong>
              </p>
              {formData.find_matches?.brands_in_space?.map((brand, idx) => (
                <p key={idx} style={dataLineStyle}>
                  {brand.brand_name} ({brand.website})
                </p>
              ))}
              <p style={dataLineStyle}>
                {formData.find_matches?.match_type || 'Match'}
              </p>
              <p style={dataLineStyle}>
              Remove previous matching: {formData.find_matches?.remove_previous_matching ? "Yes" : "No"}
              </p>
              <p style={dataLineStyle}>
                Removing existing next to brands &amp; competitors: {formData.brand_info?.remove_existing_next_to_brands_competitors ? 'Yes' : 'No'}
              </p>
            </>
          )}

          {formData.find_matches?.type === 'skipped' && (
            <p style={dataLineStyle}>Skipped</p>
          )}

        </div>
      </div>
    </div>
  );
};

const sectionStyle = {
  background: '#fafafa',
  border: '1px solid #e5e5e5',
  borderRadius: '8px',
  padding: '16px 20px',
  marginBottom: '16px',
};

const sectionHeaderStyle = {
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '12px',
};

const sectionTitleStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#222',
  margin: 0,
};

const editButtonStyle = {
  background: 'none',
  border: 'none',
  cursor: 'pointer',
  padding: '4px',
  color: '#666',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

const sectionContentStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
};

const dataLineStyle = {
  fontSize: '13px',
  color: '#666',
  margin: 0,
  lineHeight: '1.6',
};

export default Step6ReviewSubmit;
